// removed by extract-text-webpack-plugin
module.exports = {"footer":"_2yg-LLzePxiIpoBVYfNlva","navList":"_1enNMyaJXWkDGYqCLBPttO","navItem":"_2oVWAHCjUoTxf93idMZdwA","logo":"_3wkpGygCu_3JH_EdGg555m","copyright2016By":"_1lB8eA7MdgmQf8_E0LiGli"};


//////////////////
// WEBPACK FOOTER
// ./src/sections/Footer/Footer.css
// module id = 188
// module chunks = 0